module.exports = __webpack_public_path__ + "img/7.7018a1fc.png";